import css from 'styled-jsx/css';

export const styles = css`
  .AddUserEmailToSubscriptionModal__text {
    margin-bottom: 18px;
  }

  .AddUserEmailToSubscriptionModal__wrapSubmitButton {
    padding-top: 4px;
  }
  `;
